import { useEffect } from "react";
import styles from "./ErrorToast.module.css";

const AUTO_DISMISS_MS = 4000;

interface Props {
  message: string;
  onDismiss: () => void;
}

export function ErrorToast({ message, onDismiss }: Props) {
  useEffect(() => {
    const timer = setTimeout(onDismiss, AUTO_DISMISS_MS);
    return () => clearTimeout(timer);
  }, [onDismiss]);

  return (
    <output className={styles.toast} role="alert">
      <span className={styles.text}>{message}</span>
      <button type="button" className={styles.dismiss} onClick={onDismiss} aria-label="閉じる">
        &times;
      </button>
    </output>
  );
}
